import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=47aaff60&scoped=true"
import script from "./Checkout.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aaff60",
  null
  
)

export default component.exports